import { SUPPORTED_ACCOUNT_PAYMENT_METHODS } from '@/features/openTabs/constants'
import { AccountHistoryEvent } from '@/features/openTabs/types'
import { formatPrice } from '@/utils/priceHelper'
import dayjs from 'dayjs'
import { TFunction } from 'i18next'

const formatElapsedTime = (value: string, t: TFunction<'app'>): string => {
    const minutes = Math.max(1, dayjs().diff(dayjs(value), 'minute'))

    return minutes >= 60
        ? t('openTabs.time.elapsedHours', { count: Math.floor(minutes / 60) })
        : t('openTabs.time.elapsedMinutes', { count: minutes })
}

const getHistoryTitle = (event: AccountHistoryEvent, t: TFunction<'app'>): string => {
    switch (event.type) {
        case 'created':
            return t('openTabs.history.created')
        case 'order-added':
            return t('openTabs.history.orderAdded', {
                count: event.itemCount ?? event.itemNames?.length ?? 0,
            })
        case 'payment':
            return t('openTabs.history.payment', {
                method: t(
                    `openTabs.history.paymentMethod.${SUPPORTED_ACCOUNT_PAYMENT_METHODS.find((method) => method === event.paymentMethod) ?? 'other'}`
                ),
            })
        case 'closed':
            return t('openTabs.history.closed')
    }
}

export const toAccountHistoryEventView = (
    event: AccountHistoryEvent,
    t: TFunction<'app'>,
    fallbackCurrency: string
) => {
    const amount = event.amount

    return {
        id: event.id,
        time: dayjs(event.occurredAt).format('HH:mm'),
        elapsed: formatElapsedTime(event.occurredAt, t),
        title: getHistoryTitle(event, t),
        description: event.itemNames,
        amount:
            amount !== undefined
                ? formatPrice(
                      String(amount),
                      event.currency ?? fallbackCurrency,
                      event.type !== 'payment',
                      Number.isInteger(amount) ? 0 : 2
                  )
                : undefined,
        tone: event.type === 'payment' ? ('positive' as const) : ('neutral' as const),
    }
}
